import axios from 'axios';
import { logout } from '../../redux/user/user.actions';
import ToastService from '../../services/ToastService';

const REACT_APP_AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;
const REACT_APP_API = process.env.REACT_APP_API;

const mergeCommonHeaders = rest => {
  const authToken = localStorage.getItem(REACT_APP_AUTH_TOKEN);
  if (authToken) {
    return {
      ...rest,
      Authorization: `Bearer ${authToken}`
    };
  }
  return rest;
};

const client = axios.create({
  baseURL: REACT_APP_API,
  responseType: 'json'
});

client.setupInterceptores = (store, history) => {
  client.interceptors.request.use(request => {
    const headers = mergeCommonHeaders(request.headers.common);
    request.headers.common = headers;
    return request;
  });

  client.interceptors.response.use(
    success => {
      return success.data;
    },
    error => {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        store.dispatch(logout());
        history.push('/');
        ToastService.info(
          'Your login session has expired. Please login again!'
        );
      }
      const response =
        error.response && error.response.data ? error.response.data : error;
      return Promise.reject(response);
    }
  );
};

export default client;



// WEBPACK FOOTER //
// ./src/infra/http/AxiosClient.js